import { PageHeader } from "@/components/PageHeader";
import KbTidyTables from "@/components/KbTidyTables";
import KbStaleReport from "@/components/KbStaleReport";
import { KbFeedbackDigestCard } from "@/pages/settings/KbFeedbackDigestCard";
import KbRequestOwnerCard from "@/pages/settings/KbRequestOwnerCard";
import KbReviewDigestCard from "@/pages/settings/KbReviewDigestCard";
import KbLinkDigestCard from "@/pages/settings/KbLinkDigestCard";
import KbKeywordBackfillCard from "@/pages/settings/KbKeywordBackfillCard";
import KbFormattingRestoreCard from "@/pages/settings/KbFormattingRestoreCard";

const Column = ({ children, testid }) => (
  <div className="flex min-w-0 flex-col gap-4 [&>*]:!mt-0" data-testid={testid}>{children}</div>
);

/** Settings → Knowledge Base → Articles: owners, digests and housekeeping. */
export default function KbArticlesPanel() {
  return (
    <div data-testid="kb-articles-panel">
      <PageHeader compact title="Articles"
        subtitle="Who owns requests, the digests reviewers receive, and the checks that keep article content healthy" />
      <div className="grid grid-cols-1 items-start gap-4 xl:grid-cols-2">
        <Column testid="kb-articles-col-1">
          <KbRequestOwnerCard />
          <KbReviewDigestCard />
          <KbLinkDigestCard />
          <KbFeedbackDigestCard />
        </Column>
        <Column testid="kb-articles-col-2">
          <KbKeywordBackfillCard />
          <KbStaleReport />
          <KbTidyTables />
          <KbFormattingRestoreCard />
        </Column>
      </div>
    </div>
  );
}
